import React, { useEffect } from "react";

// components
import Loader from "../../Container/Loader";
import Modal from "../../Container/Modal";
import RightSideBar from "../../Container/RightSidebar";

// style
import HomeStyle from "./style";

//  images
import Sort from "../../Assets/sort.svg";
import DeleteIcon from "../../Assets/Delete.svg";
import Pen from "../../Assets/pen.svg";
import { useState } from "react";

// -- redux
import { connect } from "react-redux";
import { GetHoliday, EditHoliday, DeleteHoliday, AddHoliday } from "../../Redux/Actions/HolidayAction";

function Holidays(props) {
  const [Open, SetOpen] = useState(false);
  const [Data, SetData] = useState("");
  const [sortType, setSortType] = useState("asc");
  const [sortBy, setSortBy] = useState("description");
  const [tableEntries, setTableEntries] = useState([]);
  const [OpenModal, setModal] = useState(false);
  const [Name, setName] = useState(false);
  const [HolidayId, setHolidayId] = useState("");

  useEffect(() => {
    if (props.search.length > 0) {
      const data = {
        sort_type: sortType,
        sort_by: sortBy,
        search_key: props.search,
      };
      props.GetHoliday(data);
    } else {
      const data = {
        sort_type: sortType,
        sort_by: sortBy,
        search_key: "",
      };
      props.GetHoliday(data);
    }
    SetOpen(false);
  }, [props.delete_data, props.edit_data, props.add_data, props.update_data, props.search, props.copy_data, sortBy, sortType, props.status]);
  useEffect(() => {
    if (props.data && props.data.data) {
      setTableEntries((prevData) => {
        return [...new Set([...prevData, ...props.data.data])];
      });
    }
  }, [props.data, props.add_data, props.edit_data, props.delete_data]);
  const handleSort = (e, type) => {
    e.preventDefault();
    setSortBy(type);
    sortType === "asc" ? setSortType("desc") : setSortType("asc");
  };

  const CloseModal = (e, type) => {
    e.preventDefault();
    console.log("close modal");
    if (type === "delete_yes") {
      console.log(HolidayId);
      props.DeleteHoliday(HolidayId);
      setModal(false);
    } else if (type === "delete_no") {
      setModal(false);
    }
  };

  const deleteHoliday = (e, type, id) => {
    console.log(id);
    e.preventDefault();
    setModal(type);
    setHolidayId(id);
  };

  const handleEdit = (e, data) => {
    console.log("DATA:", data);
    e.preventDefault();
    SetData(data);
    SetOpen(true);
  };

  useEffect(() => {
    setTimeout(function () {}, 1000);
  }, []);

  useEffect(() => {
    setTableEntries([]);
  }, [props.delete_data, props.edit_data, props.add_data, props.update_data, props.copy_data, props.search, sortBy, sortType, props.status]);

  return (
    <>
      {props.loading && <Loader />}
      <div className="ml-4 mr-4">
        <div className="module-table-wrap table-responsive">
          <div className="table-wrap">
            <table className="table table-bordered m-0">
              <thead className="text-grey-6">
                <tr>
                  <th scope="col" className="dark-background cursor-pointer" onClick={(e) => handleSort(e, "Name")}>
                    <div className="d-flex justify-content-between">
                      <span className="f-16">Name</span>
                      <img src={Sort} alt="sort" className="ml-2" />
                    </div>
                  </th>
                  <th scope="col" className="dark-background cursor-pointer" onClick={(e) => handleSort(e, "date")}>
                    <div className="d-flex justify-content-between">
                      <span className="f-16">Date</span>
                      <img src={Sort} alt="sort" className="ml-2" />
                    </div>
                  </th>
                  <th scope="col" className="dark-background">
                    <span className="f-16">Action</span>
                  </th>
                </tr>
              </thead>
              <tbody className="light-grey-background text-white">
                {tableEntries.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <span className="f-16">{item.name}</span>
                    </td>
                    <td>
                      <span className="f-16">{item.date}</span>
                    </td>
                    <td>
                      <div className="d-flex">
                        <img
                          src={Pen}
                          onClick={(e) => {
                            handleEdit(e, item);
                          }}
                          alt="pen"
                          className="ml-2 mr-2 cursor-pointer"
                        />
                        <img onClick={(e) => deleteHoliday(e, "delete", item.id)} src={DeleteIcon} alt="Delete" className="ml-2 mr-3 cursor-pointer" />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <HomeStyle />
          </div>
        </div>

        <RightSideBar Type="Edit" data={Data} sidebar={Open} close={() => SetOpen(false)} response={(e) => e} />

        {OpenModal && <Modal Name={Name} Type={OpenModal} Close={(e, type) => CloseModal(e, type)} />}
      </div>
    </>
  );
}

const mapStateToProps = ({ GetHolidayReducer }) => {
  const { loading, table_loading, data, update_data, delete_data, edit_data, add_data, copy_data } = GetHolidayReducer;
  return {
    loading,
    table_loading,
    data,
    update_data,
    delete_data,
    edit_data,
    add_data,
    copy_data,
  };
};

const mapDispatchToProps = {
  GetHoliday,
  EditHoliday,
  DeleteHoliday,
  AddHoliday,
};

export default connect(mapStateToProps, mapDispatchToProps)(Holidays);
